 import React from "react";

const Footer = ({changeFooter}) => {
  let d = new Date();
  return (
    <div className={`footer ${changeFooter}`}>
      <div className="copyright">
        <p>
          LEC - Curitiba © Todos os direitos reservados.
          <br />
          Desenvolvido por{" "}
          <a href="http://www.dettalles.com.br/" target="_blank" rel="noreferrer">
            Dettalles Consultoria
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
